export default function AppHeader() {
  return (
    <div className="p-4">
      <div className="flex items-center gap-3">
        <img src="/assets/cash-jackpot.webp" alt="Jackpot Reels" className="w-16 h-16 rounded-xl" />
        <div className="flex-1">
          <h1 className="text-xl font-bold">Jackpot Reels</h1>
          <p className="text-sm text-gray-600">Downloads 100K+</p>
          <div className="flex items-center gap-1 mt-1">
            <span className="text-yellow-500">★★★★★</span>
            <span className="text-sm text-gray-700 ml-1">4.9</span>
          </div>
        </div>
      </div>

      <div className="flex gap-2 mt-3">
        {['slot', 'casino', 'Rich Rewards'].map(tag => (
          <span key={tag} className="px-3 py-1 bg-gray-100 text-xs rounded-full">
            {tag}
          </span>
        ))}
        <span className="px-2 py-1 bg-gray-200 text-xs rounded">18+</span>
      </div>
    </div>
  );
}